import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_v18xzsq";
const TEMPLATE_ID =
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_6sifady";
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "qCTIl-A5butAP0y4v";

export default function Contact({ github }) {
  const form = useRef(null);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const githubProfile = github?.profile || {};
  const githubLogin = githubProfile.login || "brysonwaisi";

  function validate(f) {
    const e = {};
    if (!f.name.trim()) e.name = "Please enter your full name.";
    if (!f.email.trim()) e.email = "Email is required.";
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(f.email.trim()))
      e.email = "Please enter a valid email address.";
    if (!f.message.trim()) e.message = "Please enter your message.";
    return e;
  }

  function submit(ev) {
    ev.preventDefault();
    const data = {
      name: form.current.name.value,
      email: form.current.email.value,
      message: form.current.message.value,
    };
    const eMap = validate(data);
    if (Object.keys(eMap).length) {
      setErrors(eMap);
      setStatus("idle");
      return;
    }
    setErrors({});
    setStatus("sending");
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY).then(
      () => {
        setStatus("sent");
        form.current.reset();
      },
      (err) => {
        console.error(err);
        setStatus("error");
      },
    );
  }

  return (
    <section id="contact">
      <div className="section-head">
        <div className="label">§07 · contact</div>
        <div className="h">Reach out</div>
        <div className="meta"></div>
      </div>

      <div className="contact-grid">
        <div className="pane">
          <div className="pane-hd">
            <div className="dots">
              <i />
              <i />
              <i />
            </div>
            <div className="path">bryson nyamwange: ~ /tmp/hire-me</div>
            <div className="pane-hd-status">● connected</div>
          </div>
          <form className="term-body" ref={form} onSubmit={submit} noValidate>
            <p>
              <span className="ok">$</span> auth --status
            </p>
            <p className="mu">
              # authenticated as guest@external. opening secure channel...
            </p>
            <p>
              <span className="ok">$</span> compose --to bryson
            </p>

            <label htmlFor="name">name</label>
            <input
              id="name"
              name="name"
              placeholder="ada lovelace"
              aria-invalid={!!errors.name}
            />
            {errors.name && (
              <span className="field-error">
                {errors.name}
              </span>
            )}

            <label htmlFor="email">email</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="ada@analytical.engine"
              aria-invalid={!!errors.email}
            />
            {errors.email && (
              <span className="field-error">
                {errors.email}
              </span>
            )}

            <label htmlFor="message">message</label>
            <textarea
              id="message"
              name="message"
              placeholder="We're a Series B fintech; we need someone to own payments rails..."
              aria-invalid={!!errors.message}
            />
            {errors.message && (
              <span className="field-error">
                {errors.message}
              </span>
            )}

            <button
              type="submit"
              className="send"
              disabled={status === "sending"}
            >
              {status === "sent" ? (
                "✓ message sent"
              ) : status === "sending" ? (
                "transmitting..."
              ) : (
                <>
                  send <span className="arrow">↵</span>
                </>
              )}
            </button>
            {status === "sent" && (
              <p className="send-msg ok">
                {"// Success — i'll be in touch within 24h."}
              </p>
            )}
            {status === "error" && (
              <p className="send-msg err">
                {"// Failed! — try again or email directly."}
              </p>
            )}
          </form>
        </div>

        <div className="links">
          <a className="link-row" href="mailto:brysonnyamwange@gmail.com">
            <span className="k">email</span>
            <span className="v">brysonnyamwange@gmail.com</span>
            <span className="a">send ↗</span>
          </a>
          <a
            className="link-row"
            href="https://github.com/brysonwaisi"
            target="_blank"
            rel="noreferrer"
          >
            <span className="k">github</span>
            <span className="v">@{githubLogin}</span>
            <span className="a">open ↗</span>
            <span className="sr-only">(opens in new tab)</span>
          </a>
          <a
            className="link-row"
            href="https://www.linkedin.com/in/nyamwangeb/"
            target="_blank"
            rel="noreferrer"
          >
            <span className="k">linkedin</span>
            <span className="v">/in/nyamwangeb</span>
            <span className="a">open ↗</span>
            <span className="sr-only">(opens in new tab)</span>
          </a>
          <a
            className="link-row"
            href="https://www.nyamwangeb.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span className="k">website</span>
            <span className="v">nyamwangeb.com</span>
            <span className="a">open ↗</span>
            <span className="sr-only">(opens in new tab)</span>
          </a>
          <a
            className="link-row"
            href="https://medium.com/@brysonnyamwange"
            target="_blank"
            rel="noreferrer"
          >
            <span className="k">writing</span>
            <span className="v">medium / @brysonnyamwange</span>
            <span className="a">open ↗</span>
            <span className="sr-only">(opens in new tab)</span>
          </a>
          <a
            className="link-row"
            href={process.env.PUBLIC_URL + "/assets/Nyamwange.pdf"}
            download
          >
            <span className="k">cv</span>
            <span className="v">Nyamwange.pdf</span>
            <span className="a">download ↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
